import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=c8d1bbcc&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"
import style0 from "./recordList.vue?vue&type=style&index=0&id=c8d1bbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d1bbcc",
  null
  
)

export default component.exports